import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import { Container, Grid } from '@mui/material';
import SignupForm from '../sections/auth/signup/SignupForm';

const PageRoot = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
}));

const Content = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  margin: 0,
  padding: 0,
}));

export default function SignupPage() {
  return (
    <>
      <Helmet>
        <title>New Member Registration — MTC-FS</title>
      </Helmet>

      <PageRoot>
        <Container maxWidth={false} disableGutters sx={{ p: 0 }}>
          <Content>
            <Grid container spacing={0} justifyContent="center">
              <Grid item xs={12} sx={{ width: '100%' }}>
                <SignupForm />
              </Grid>
            </Grid>
          </Content>
        </Container>
      </PageRoot>
    </>
  );
}
